export default __webpack_public_path__ + "static/media/mongodb.0e2eaa17.png";